import React from "react";

export default function About() {
  const version = "0.1.0";

  return <div>version: {version}</div>;
}
